// AUTO-GENERATED — do not edit manually.
// Generated: 2026-10-28 19:12 UTC
// Regenerate: python swak_tools.py generate_campus_data_js
// Campuses: 123

window.SWAK_CAMPUS_DATA = {
  "bakeru": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Baker University",
    "sponsor_school": "Baker University",
    "sponsor_org": "the Residence Life Department",
    "primary_color": "#f58025",
    "internal_order_code": "ks-bakeru",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/bakeru-campus.jpg?v=1786842395",
    "color_bar_bg": "bg=#1E2D50",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#f58025",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#f58025;btn2_bg=#1E2D50;badge_bg=#1b3a6b",
    "color_fulfillment": "#1E2D50",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 26, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 15, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 10, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Pickup will be at Harter Union 207, Monday thru Friday, 9-4.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "baylor": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Baylor University",
    "sponsor_school": "Baylor University",
    "sponsor_org": "Campus Living & Learning",
    "primary_color": "#154734",
    "internal_order_code": "tx-baylor",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/baylor-campus.jpg?v=1788874081",
    "color_bar_bg": "",
    "color_bar_text": "#FFB81C",
    "color_hero_text": "#FFB81C",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#FFB81C",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#FFB81C;btn1_text=#154734",
    "color_fulfillment": "bg=#FFB81C;text=#154734",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 3, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 29, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care Packages will be delivered through the Mail Center located in the Bill Daniels Student Center (or mailroom at University Park).", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["One Bear Place", "University Park"],
    "room_required": "false",
    "room_label": "Box # or Apt #"
  },
  "bellarmine": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Bellarmine",
    "sponsor_school": "Bellarmine University",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#752936",
    "internal_order_code": "ks-bellarmine",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/bellarmine-campus.jpg?v=1784948113",
    "color_bar_bg": "bg=#ffffff;border=#752936",
    "color_bar_text": "#752936",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "",
    "color_buttons": "btn1_bg=#ffc72a;btn1_text=#752936",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 27, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 24, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 11, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 16, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students are notified to pick up their package in the Residence Life Office in Petrik Hall.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "boisestate": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Boise State University",
    "sponsor_school": "Boise State University",
    "sponsor_org": "Residence Life and the Honors Student Association",
    "primary_color": "#0033A0",
    "internal_order_code": "id-boisestate",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/boisestate-campus.jpg?v=1784861310",
    "color_bar_bg": "bg=#ffffff;border=#0033A0",
    "color_bar_text": "#0033A0",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#D64309",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#D64309;btn2_bg=#D64309",
    "color_fulfillment": "#D64309",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 7, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 26, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Pickup is at the Residence Hall Front Desk. Students will receive an email from the front desk when packages are ready.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Chaffee", "Driscoll", "Garnet", "Honors", "Jade", "Jasper", "Keiser", "Morrison", "Sawtooth", "Syringa", "Taylor", "Topaz Halls", "Towers", "University Suites", "Unknown"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "bradley": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Bradley University",
    "sponsor_school": "Bradley University",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#CE1432",
    "internal_order_code": "il-bradley",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/bradley-campus.jpg?v=1784864010",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#CE1432",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "bg=#5a5a5c",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "September 2, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 2, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 3, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "bsu": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Ball State University",
    "sponsor_school": "Ball State University",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#BA0C2F",
    "internal_order_code": "in-bsu",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/bsu-campus.jpg?v=1788300262",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "#BA0C2F",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "bg=#54585A",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 4, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 11, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 20, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will pick up their package at their Residence Hall.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Anthony", "Baker", "Beyerl", "Botsford/Swinford", "Brady", "Crosley", "Davidson", "DeHority", "Kinghorn", "Klipple", "North West Hall", "Painter", "Palmer", "Park", "Rogers", "Scheidler", "Schmidt-Wilson", "Studebaker East", "Whitcraft", "Wood (in Woodworth Complex)"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "buffalo": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "University at Buffalo",
    "sponsor_school": "the University at Buffalo",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#005bbb",
    "internal_order_code": "ny-buffalo",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/buffalo-campus.jpg?v=1785121032",
    "color_bar_bg": "bg=#005bbb",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#005bbb",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 1, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 28, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "canton": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "SUNY Canton",
    "sponsor_school": "SUNY Canton",
    "sponsor_org": "the Residence Life Department",
    "primary_color": "#00A160",
    "internal_order_code": "ny-canton",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/canton-campus.jpg?v=1788561792",
    "color_bar_bg": "bg=#004B8D;border=#00A160",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#004B8D",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#004B8D;btn2_bg=#004B8D;badge_bg=#004B8D",
    "color_fulfillment": "bg=#004B8D",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "September 3, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 7, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 3, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will pick up their care package from the RA Office in their Residence Hall.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "carthage": {
    "care_on": false, "care_off": false,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": false, "care_on_valentines": false,
    "care_on_springsurprise": false, "care_on_springfinals": false,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": false, "care_off_valentines": false,
    "care_off_springsurprise": false, "care_off_springfinals": false,
    "name": "Carthage College",
    "sponsor_school": "Carthage College",
    "sponsor_org": "the Office of Residential Life",
    "primary_color": "#D01c2e",
    "internal_order_code": "wi-carthage",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/carthage-campus.jpg?v=1784516543",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "",
    "color_buttons": "btn2_bg=#000000",
    "color_fulfillment": "",
    "kd_welcome_deadline": "",
    "kd_welcome_availability": "",
    "kd_halloween_deadline": "",
    "kd_halloween_availability": "",
    "kd_fallfinals_deadline": "",
    "kd_fallfinals_availability": "",
    "kd_valentines_deadline": "",
    "kd_valentines_availability": "",
    "kd_springsurprise_deadline": "",
    "kd_springsurprise_availability": "",
    "kd_springfinals_deadline": "",
    "kd_springfinals_availability": "",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "columbia": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Columbia University",
    "sponsor_school": "Columbia University",
    "sponsor_org": "the Residence Hall Leadership Organization (RHLO) and National Residence Hall Honorary (NRHH)",
    "primary_color": "#1D4F91",
    "internal_order_code": "ny-columbia",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/columbia-campus.jpg?v=1786072793",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "September 4, 2026",
    "kd_welcome_availability": "September 15, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 8, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 27, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Packages are delivered through the mailroom/mail center. Students are emailed by the mailroom to pick up their packages once they're sorted and ready for pickup. That timeframe varies depending on the bulk of the mail.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "UNI #"
  },
  "csupueblo": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": false, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": false, "care_off_springfinals": true,
    "name": "CSU Pueblo",
    "sponsor_school": "Colorado State University Pueblo",
    "sponsor_org": "Residence Life & Housing",
    "primary_color": "#00205C",
    "internal_order_code": "co-csupueblo",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/csupueblo-campus.jpg?v=1785556781",
    "color_bar_bg": "bg=#ffffff;border=#00205C",
    "color_bar_text": "#00205C",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "#CC3333",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#CC3333;btn2_bg=#CC3333",
    "color_fulfillment": "bg=#CC3333",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "",
    "kd_halloween_availability": "",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "",
    "kd_springsurprise_availability": "",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 26, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students are emailed to pick up their packages in the Housing Office.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "csus": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Sacramento State",
    "sponsor_school": "California State University, Sacramento",
    "sponsor_org": "the Residence Hall Association in University Housing Services",
    "primary_color": "#004e38",
    "internal_order_code": "ca-csus",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/csus-campus.jpg?v=1788984533",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "",
    "color_buttons": "btn1_bg=#c4b581;btn1_text=#043927",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 28, 2026",
    "kd_welcome_availability": "September 7, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 7, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 15, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 11, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "All student care packages are delivered to the package pickup location in the Hornet mail center.  Students are notified via school email.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["American River Courtyard", "Desmond", "Draper", "Hornet Commons", "Jenkins", "Riverview", "Sierra", "Sutter", "Upper Eastside Lofts", "Unknown"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "cwu": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Central Washington University",
    "sponsor_school": "Central Washington University",
    "sponsor_org": "Housing and Residence Life",
    "primary_color": "#A30F32",
    "internal_order_code": "wa-cwu",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/cwu-campus.jpg?v=1786153322",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "September 15, 2026",
    "kd_welcome_availability": "September 30, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "May 15, 2027",
    "kd_springfinals_availability": "May 31, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students have been notified via school email that packages are available for pickup in the Housing & Residence Life Office.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "delhi": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "SUNY Delhi",
    "sponsor_school": "SUNY Delhi",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#024712",
    "internal_order_code": "ny-delhi",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/delhi-campus.jpg?v=1789446464",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#FDCC00",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#FDCC00;btn1_text=#024712",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 28, 2026",
    "kd_welcome_availability": "September 7, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 7, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 28, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Student will pick up their package at the Student Mailroom (Farrell Hall Lower Level) Monday to Friday, 9-5.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "doane": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Doane University",
    "sponsor_school": "Doane University",
    "sponsor_org": "the Office of Residence Life and Education",
    "primary_color": "#ff7900",
    "internal_order_code": "ne-doane",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/doane-campus.jpg?v=1791143750",
    "color_bar_bg": "bg=#ffffff;border=#ff7900",
    "color_bar_text": "#000000",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#ff7900",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn2_bg=#000000;btn2_text=#ff7900",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 24, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 3, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students are emailed and texted to pick up their packages at the Student Affairs Perry Pod in Perry Campus Center.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "du": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "University of Denver",
    "sponsor_school": "the University of Denver",
    "sponsor_org": "Housing and Residential Education",
    "primary_color": "#BA0C2F",
    "internal_order_code": "co-du",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/du-campus.jpg?v=1786071186",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "September 1, 2026",
    "kd_welcome_availability": "September 15, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 2, 2026",
    "kd_fallfinals_availability": "November 12, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 25, 2027",
    "kd_springsurprise_availability": "March 15, 2027",
    "kd_springfinals_deadline": "May 15, 2027",
    "kd_springfinals_availability": "May 31, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "ecu": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "East Carolina University",
    "sponsor_school": "East Carolina University",
    "sponsor_org": "the East Carolina University Ambassadors",
    "primary_color": "#592A8A",
    "internal_order_code": "nc-ecu",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/ecu-campus.jpg?v=1788392012",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#FEC923",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#FEC923;btn1_text=#592A8A",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 24, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 26, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will be notified to pick up their packages through the regular package system.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Ballard East", "Ballard West", "Clement", "College Hill Suites", "Cotten", "Fletcher", "Flemming", "Garrett", "Greene", "Jarvis", "Jones", "Legacy", "Scott", "Tyler", "Umstead", "White", "Unknown"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "eku": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Eastern Kentucky University",
    "sponsor_school": "Eastern Kentucky University",
    "sponsor_org": "the Student Alumni Ambassadors",
    "primary_color": "#861f41",
    "internal_order_code": "ky-eku",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/eku-campus.jpg?v=1784948399",
    "color_bar_bg": "bg=#ffffff;border=#000000",
    "color_bar_text": "#861f41",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#861f41",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "bg=#2d3136",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10,2026",
    "kd_halloween_availability": "October 29,2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 3, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "eou": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Eastern Oregon University",
    "sponsor_school": "Eastern Oregon University",
    "sponsor_org": "the Office of Residence Life",
    "primary_color": "#002855",
    "internal_order_code": "or-eou",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/eou-campus.jpg?v=1786295293",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "#b58c0a",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#b58c0a;btn1_text=#002855",
    "color_fulfillment": "bg=#b58c0a;text=#000000",
    "kd_welcome_deadline": "September 15, 2026",
    "kd_welcome_availability": "October 5, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 15, 2027",
    "kd_springfinals_deadline": "May 15, 2027",
    "kd_springfinals_availability": "May 31, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Packages will be available at the students' hall's mailroom. Students should take the package notice found in their mailbox to the mail counter to pick up their package.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "erauaz": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Embry-Riddle Prescott",
    "sponsor_school": "Embry-Riddle Aeronautical University, Prescott",
    "sponsor_org": "Housing and Residence Life",
    "primary_color": "#03539E",
    "internal_order_code": "az-erauaz",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/erauaz-campus.jpg?v=1784834866",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#ffcb06",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#ffcb06;btn1_text=#03539E",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2026",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 23, 2027",
    "kd_room_oncampus_deadline": "July 26, 2026",
    "kd_room_offcampus_deadline": "July 26, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "etsu": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "East Tennessee State University",
    "sponsor_school": "East Tennessee State University",
    "sponsor_org": "New Student and Family Programs",
    "primary_color": "#00053E",
    "internal_order_code": "tn-etsu",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/etsu-campus.jpg?v=1785205641",
    "color_bar_bg": "bg=#ffffff;border=#000000",
    "color_bar_text": "#00053E",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#FFC72C",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#FFC72C;btn1_text=#00053E;btn2_bg=#00053E",
    "color_fulfillment": "bg=#FFC72C;text=#00053E",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 23, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Mail Box #"
  },
  "fhsu": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Fort Hays State University",
    "sponsor_school": "Fort Hays State University",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#FDB913",
    "internal_order_code": "ks-fhsu",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/fhsu-campus.jpg?v=1785001297",
    "color_bar_bg": "",
    "color_bar_text": "#000000",
    "color_hero_text": "#ffffff",
    "color_heading_room": "#FDB913",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_text=#000000;btn2_text=#000000",
    "color_fulfillment": "text=#000000",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 24, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 3, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Agnew", "Custer", "Hansen", "Heather", "McMindes", "Stadium Place", "Tiger Village", "Victor E. Village", "Wooster", "Unknown"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "fit": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Florida Tech",
    "sponsor_school": "Florida Tech",
    "sponsor_org": "the Division of Student Affairs",
    "primary_color": "#770000",
    "internal_order_code": "fl-fit",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/fit-campus.jpg?v=1785640672",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "",
    "color_buttons": "",
    "color_fulfillment": "bg=#AB946C;text=#000000",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 24, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 1, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 23, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Packages have been sorted and moved to their residential areas for distribution.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "fiu": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Florida International University",
    "sponsor_school": "Florida International University",
    "sponsor_org": "the Orientation and Family Programs",
    "primary_color": "#081E3F",
    "internal_order_code": "fl-fiu",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/fiu-campus.jpg?v=1785809794",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "#D1A644",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#D1A644;btn1_text=#081E3F;btn2_bg=#D1A644;btn2_text=#081E3F",
    "color_fulfillment": "bg=#081E3F",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 11, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 19, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "All students will be notified via their FIU email when their package is delivered/ready to be picked up at the Housing and Residential Life Package Center located in Lakeview South Hall.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Bayview Student Living", "Everglades Hall", "Lakeview Hall North", "Lakeview Hall South", "Panther Hall", "Parkview Hall", "Tamiami Hall", "University Apartments", "University Towers"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "fresnostate": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": false, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": false, "care_off_springfinals": true,
    "name": "Fresno State",
    "sponsor_school": "Fresno State",
    "sponsor_org": "Fresno State Student Housing",
    "primary_color": "#b1102b",
    "internal_order_code": "ca-fresnostate",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/fresnostate-campus.jpg?v=1784838685",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "bg=#13284c",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 26, 2026",
    "kd_halloween_deadline": "",
    "kd_halloween_availability": "",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 7, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "",
    "kd_springsurprise_availability": "",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 10, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "The package locker system sends out package pickup instructions.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Aspen", "Baker", "Birch", "Cedar", "Graves", "Homan", "Ponderosa", "Sequoia", "Sycamore", "Unknown"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "fsu": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Florida State University",
    "sponsor_school": "Florida State University",
    "sponsor_org": "the National Residence Hall Honorary",
    "primary_color": "#782F40",
    "internal_order_code": "fl-fsu",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/fsu-campus.jpg?v=1784856762",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#CEB888",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#CEB888;btn1_text=#000000",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 19, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students are emailed to pick up packages at their Residence Hall's Hub Desk.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "gatech": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Georgia Tech",
    "sponsor_school": "the Georgia Institute of Technology",
    "sponsor_org": "Parent and Family Programs",
    "primary_color": "#B39051",
    "internal_order_code": "ga-gatech",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/gatech-campus.jpg?v=1785880362",
    "color_bar_bg": "bg=#ffffff;border=#000000",
    "color_bar_text": "#B39051",
    "color_hero_text": "",
    "color_heading_room": "#B39051",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#B39051",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 2, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 15, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 22, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will be notified by school email to pick up their package in the mailroom.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "true",
    "room_label": "Mail Box # - Format 6 Digits only"
  },
  "gcsu": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Georgia College",
    "sponsor_school": "Georgia College & State University",
    "sponsor_org": "the Resident Student Association",
    "primary_color": "#005029",
    "internal_order_code": "ga-gcsu",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/gcsu-campus.jpg?v=1785896011",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn2_bg=#013366",
    "color_fulfillment": "bg=#013366",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 24, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 1, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 29, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "GCSU hand delivers to your student's room.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "gonzaga": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Gonzaga University",
    "sponsor_school": "Gonzaga University",
    "sponsor_org": "the New Student & Family Programs Office",
    "primary_color": "#041E42",
    "internal_order_code": "wa-gonzaga",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/gonzaga-campus.jpg?v=1789692117",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#5e8ab4",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#5e8ab4;btn2_bg=#5e8ab4",
    "color_fulfillment": "bg=#5e8ab4",
    "kd_welcome_deadline": "August 28, 2026",
    "kd_welcome_availability": "September 8, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 4, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 23, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students are text notified to pick up their packages at Parent and Family Relations Crosby 100", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "illinois": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "University of Illinois",
    "sponsor_school": "the University of Illinois Urbana-Champaign",
    "sponsor_org": "University Housing",
    "primary_color": "#FF5F05",
    "internal_order_code": "il-illinois",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/illinois-campus.jpg?v=1788268513",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#FF5F05",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn2_bg=#13294B;badge_bg=#13294B",
    "color_fulfillment": "bg=#13294B",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 3, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 29, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "RHA will attempt to hand-deliver your student's package.  If they haven't connected with your student, the package will be available for pick up at your students' hall front desk (and your student will be notified via email).  Please have your student check the pickup location listed there before contacting us.  Even though it's nice to send the package as a surprise, you don't want your student to miss out on all the goodies so we encourage you to check with them that they did receive their package before it's too late.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Allen", "Babcock", "Barton", "Blaisdell", "Bousfield", "Busey", "Carr", "Daniels", "Evans", "Hopkins", "Leonard", "Lundgren", "Nugent", "Oglesby", "Saunders", "Scott", "Shelden", "Sherman", "Snyder", "Taft", "Townsend", "Trelease", "VanDoren", "Wardall", "Wassaja", "Weston"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "illinoisstate": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Illinois State",
    "sponsor_school": "Illinois State University",
    "sponsor_org": "the Association of Residence Halls",
    "primary_color": "#CE1126",
    "internal_order_code": "il-illinoisstate",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/illinoisstate-campus.jpg?v=1784911636",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 24, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 23, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students pick up packages at their area mailroom. They should receive an email when it is ready for pickup.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "lcsc": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": false,
    "care_on_springsurprise": false, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": false,
    "care_off_springsurprise": false, "care_off_springfinals": true,
    "name": "Lewis-Clark State College",
    "sponsor_school": "Lewis-Clark State College",
    "sponsor_org": "the Office of Residence Life",
    "primary_color": "#003865",
    "internal_order_code": "id-lcsc",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/lcsc-campus.jpg?v=1789009650",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "",
    "kd_welcome_availability": "",
    "kd_halloween_deadline": "",
    "kd_halloween_availability": "",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "",
    "kd_valentines_availability": "",
    "kd_springsurprise_deadline": "",
    "kd_springsurprise_availability": "",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 26, 2027",
    "kd_room_oncampus_deadline": ",",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Residence Life distributes the packages to students.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "longwood": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Longwood University",
    "sponsor_school": "Longwood University",
    "sponsor_org": "the Residential and Commuter Life Department",
    "primary_color": "#002147",
    "internal_order_code": "va-longwood",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/longwood-campus.jpg?v=1785290505",
    "color_bar_bg": "bg=#002147",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#f17520",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#f17520;btn1_text=#002147",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 26, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will be notified via school email to pick up their package at the ResLife Office in Eason G13", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "louisville": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "University of Louisville",
    "sponsor_school": "the University of Louisville",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#ad0000",
    "internal_order_code": "ky-louisville",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/louisville-campus.jpg?v=1787257883",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "",
    "color_buttons": "badge_bg=#000000",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 24, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 24, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 15, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students can pickup their package at the RHA & NRHH Office located behind the front desk in the main lobby at 1900 South Fourth Street, Louisville, Kentucky, 40208.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "loyola": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Loyola University Maryland",
    "sponsor_school": "Loyola University Maryland",
    "sponsor_org": "Residence Life & Housing",
    "primary_color": "#003D34",
    "internal_order_code": "md-loyola",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/loyola-campus.jpg?v=1785010409",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "#009164",
    "color_heading_care_bottom": "",
    "color_buttons": "btn1_bg=#009164",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 28, 2026",
    "kd_welcome_availability": "September 7, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 3, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 11, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 21, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students pick up their package at the Student Mail Center.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Box #"
  },
  "marian": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": false, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": false, "care_off_springfinals": true,
    "name": "Marian University",
    "sponsor_school": "Marian University",
    "sponsor_org": "the Residential & Commuter Life Department",
    "primary_color": "#031E51",
    "internal_order_code": "in-marian",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/marian-campus.jpg?v=1788315563",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "#FDB813",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#FDB813;btn1_text=#031E51;btn2_bg=#FDB813;btn2_text=#031E51",
    "color_fulfillment": "bg=#FDB813;text=#031E51",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "",
    "kd_halloween_availability": "",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 7, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "",
    "kd_springsurprise_availability": "",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 19, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students are emailed to pick up their Care Package at the mailroom.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "marist": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Marist University",
    "sponsor_school": "Marist College",
    "sponsor_org": "Housing & Residential Life and the Residence Hall Association",
    "primary_color": "#C8102E",
    "internal_order_code": "ny-marist",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/marist-campus.jpg?v=1789520786",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#C8102E",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "bg=#616362",
    "kd_welcome_deadline": "August 28, 2026",
    "kd_welcome_availability": "September 7, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 7, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 3, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students pick up their package at the Champagnat Breezeway.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "mc": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Mississippi Christian University",
    "sponsor_school": "Mississippi Christian University",
    "sponsor_org": "the Residence Life Department",
    "primary_color": "#0C2340",
    "internal_order_code": "ms-mc",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/mc-campus.jpg?v=1785036297",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#C99700",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#C99700;btn1_text=#0C2340",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 24, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 24, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 22, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "mgccc": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": false, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": false, "care_off_springfinals": true,
    "name": "MGCCC",
    "sponsor_school": "Mississippi Gulf Coast Community College",
    "sponsor_org": "the Office of Residence Life",
    "primary_color": "#041E41",
    "internal_order_code": "ms-mgccc",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/mgccc-campus.jpg?v=1787712028",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "#FFB819",
    "color_heading_care_bottom": "",
    "color_buttons": "btn1_bg=#FFB819;btn1_text=#041E41",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 27, 2026",
    "kd_halloween_deadline": "",
    "kd_halloween_availability": "",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "",
    "kd_springsurprise_availability": "",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 26, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will pick up their care package at the Housing Office.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "midland": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": false, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": false, "care_off_springfinals": true,
    "name": "Midland College",
    "sponsor_school": "Midland College",
    "sponsor_org": "the Residence Life Department",
    "primary_color": "#215732",
    "internal_order_code": "tx-midland",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/midland-campus.jpg?v=1788890940",
    "color_bar_bg": "bg=#ffffff;border=#215732",
    "color_bar_text": "#215732",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#209d54",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#209d54",
    "color_fulfillment": "bg=#209d54",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "",
    "kd_halloween_availability": "",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "",
    "kd_springsurprise_availability": "",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 3, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will pick up their Care Package at the Residence Hall's front desk or their Area Office. They will be notified via school email when it is ready for pick up.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "mines": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Colorado School of Mines",
    "sponsor_school": "the Colorado School of Mines",
    "sponsor_org": "the Campus Living Student Association",
    "primary_color": "#21314d",
    "internal_order_code": "co-mines",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/mines-campus.jpg?v=1785468889",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "",
    "color_buttons": "btn1_bg=#879EC3",
    "color_fulfillment": "bg=#879EC3",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 28, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 3, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 15, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 30, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "moreheadstate": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Morehead State University",
    "sponsor_school": "Morehead State University",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#0033a0",
    "internal_order_code": "ky-moreheadstate",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/moreheadstate-campus.jpg?v=1787279297",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#ffcf00",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#ffcf00;btn1_text=#000000;btn2_bg=#ffcf00;btn2_text=#000000",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 24, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 26, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Alumni Tower", "Andrews Hall", "Cartmell Hall", "Fields Hall", "Grote-Thompson", "Mignon Complex", "Normal", "Nunn Hall", "Unknown"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "msstate": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Mississippi State University",
    "sponsor_school": "Mississippi State University",
    "sponsor_org": "the Department of Housing & Residence Life",
    "primary_color": "#5d1725",
    "internal_order_code": "ms-msstate",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/msstate-campus.jpg?v=1784514744",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 26, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 24, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 27, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care packages will be hand-delivered by RA to your student's room. If your student doesn't have the package, please have your student check with their RA.", "section": "please have your student check with their RA."}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "mssu": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Missouri Southern",
    "sponsor_school": "Missouri Southern State University",
    "sponsor_org": "the Residence Life Department",
    "primary_color": "#006937",
    "internal_order_code": "mo-mssu",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/mssu-campus.jpg?v=1787325014",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#F3D03E",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#F3D03E;btn1_text=#000000",
    "color_fulfillment": "bg=#F3D03E;text=#000000",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 24, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 15, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 3, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "msubillings": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "MSU Billings",
    "sponsor_school": "Montana State University Billings",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#15356D",
    "internal_order_code": "mt-msubillings",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/msubillings-campus.jpg?v=1785072056",
    "color_bar_bg": "",
    "color_bar_text": "#F0B310",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#F0B310",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#F0B310;btn1_text=#15356D",
    "color_fulfillment": "",
    "kd_welcome_deadline": "September 4, 2026",
    "kd_welcome_availability": "September 16, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 7, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 26, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will pick up their Care Package at their Residence Hall's front desk. They will be notified via school email.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "mtsu": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Middle Tennessee State University",
    "sponsor_school": "Middle Tennessee State University",
    "sponsor_org": "the Parent and Family Association",
    "primary_color": "#007bc3",
    "internal_order_code": "tn-mtsu",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/mtsu-campus.jpg?v=1785206596",
    "color_bar_bg": "#007bc3",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#007bc3",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "bg=#004776",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 24, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 22, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Pickup is at the residence hall front desk. Students will pick up their package at the MTSU Post Office. Students will be notified by school email when it is ready for pick up.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Box #"
  },
  "nau": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Northern Arizona University",
    "sponsor_school": "Northern Arizona University",
    "sponsor_org": "the Campus Living Student Association (CLSA)",
    "primary_color": "#002454",
    "internal_order_code": "az-nau",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/nau-campus.jpg?v=1782089673",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#FAC01A",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#FAC01A;btn1_text=#002454",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 26, 2027",
    "kd_room_oncampus_deadline": "July 26, 2026",
    "kd_room_offcampus_deadline": "July 26, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students can pick up packages in the University Union in the CLSA/NRHH Office (Room 204) which is on the second floor. Office hours are texted to students.", "section": ""}],
    "room_faq": [{"question": "Where do we pick up our Room Essentials for On-Campus deliveries?", "answer": "Room Essentials orders for On-Campus delivery are delivered to the NAU [building/location]. Students will receive an email notification when their package is ready for pickup.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "ndsu": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "North Dakota State University",
    "sponsor_school": "North Dakota State University",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#00583D",
    "internal_order_code": "nd-ndsu",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/ndsu-campus.jpg?v=1788472285",
    "color_bar_bg": "bg=#00583D;border=#FFC425",
    "color_bar_text": "#FFC425",
    "color_hero_text": "#FFC425",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#FFC425",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#FFC425;btn1_text=#00583D;badge_text=#FFC425",
    "color_fulfillment": "text=#FFC425",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 4, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 3, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students have been texted to go to their assigned halls and pick up their packages from the Hall Front Desk between 6-9pm.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Burgum", "Cater", "Churchill", "Dinan", "MLLC", "Niskanen-Middle/North/South", "NDSU Apts (Bison Court & UnivVillage)", "Pavek", "ReedJohnson", "Sevrinson", "Stockbridge", "Thompson", "Weible", "Unknown"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "newhaven": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "University of New Haven",
    "sponsor_school": "the University of New Haven",
    "sponsor_org": "the Office of Residential Life",
    "primary_color": "#002d72",
    "internal_order_code": "ct-newhaven",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/newhaven-campus.jpg?v=1785640930",
    "color_bar_bg": "bg=#ffffff;border=#000000",
    "color_bar_text": "#002d72",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#ffc72c",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#ffc72c;btn1_text=#002d72",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 1, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 29, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students are emailed and texted to pick up their packages at the Office of Residential Life.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "newpaltz": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "SUNY New Paltz",
    "sponsor_school": "SUNY New Paltz",
    "sponsor_org": "the Residence Hall Student Association",
    "primary_color": "#003e7e",
    "internal_order_code": "ny-newpaltz",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/newpaltz-campus.jpg?v=1785121731",
    "color_bar_bg": "bg=#003e7e;border=#f58426",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#f58426",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#f58426;btn2_bg=#f58426",
    "color_fulfillment": "bg=#f58426",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 3, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 7, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "nic": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": false, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": false, "care_off_springfinals": true,
    "name": "North Idaho College",
    "sponsor_school": "North Idaho College",
    "sponsor_org": "the Office of Residence Life",
    "primary_color": "#98002E",
    "internal_order_code": "id-nic",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/nic-campus.jpg?v=1788213330",
    "color_bar_bg": "bg=#ffffff;border=#98002E",
    "color_bar_text": "#000000",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "#98002E",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "",
    "kd_halloween_availability": "",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 7, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "",
    "kd_springsurprise_availability": "",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 3, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Residence Life distributes the packages.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "nku": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Northern Kentucky University",
    "sponsor_school": "Northern Kentucky University",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#ffc72c",
    "internal_order_code": "ky-nku",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/nku-campus.jpg?v=1788319059",
    "color_bar_bg": "bg=#ffffff;border=#000000",
    "color_bar_text": "#000000",
    "color_hero_text": "#000000",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "ffc72c",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_text=#000000;btn2_text=#000000;badge_text=#000000",
    "color_fulfillment": "text=#000000",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10,2026",
    "kd_halloween_availability": "October 29,2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 4, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 23, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "RHA attempts to hand delivery. Students who aren't reached will be notified with package pickup instructions.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Callahan Hall", "Commonwealth Hall", "Kentucky Hall", "New Residence Hall", "Norse Hall", "Northern Terrace", "University Suites", "Unknown"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "oakland": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": false, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": false, "care_off_springfinals": true,
    "name": "Oakland University",
    "sponsor_school": "Oakland University",
    "sponsor_org": "the Residence Life Association",
    "primary_color": "#BC945B",
    "internal_order_code": "mi-oakland",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/oakland-campus.jpg?v=1789334985",
    "color_bar_bg": "bg=#ffffff;border=#000000",
    "color_bar_text": "#BC945B",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#BC945B",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#FFCD00;btn1_text=#000000",
    "color_fulfillment": "bg=#FFCD00;text=#000000",
    "kd_welcome_deadline": "August 28, 2026",
    "kd_welcome_availability": "September 10, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 1, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "",
    "kd_springsurprise_availability": "",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 14, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students should go to the service desk in their community to pick up their package. Hours are 10am-8pm M-F, and 10am-5pm on the weekends!.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Hamlin", "Hillcrest", "Oak View", "Vandenberg", "Unknown"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "oberlin": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Oberlin College and Conservatory",
    "sponsor_school": "Oberlin College & Conservatory",
    "sponsor_org": "the Office of Residence Life",
    "primary_color": "#A6192E",
    "internal_order_code": "oh-oberlin",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/oberlin-campus.jpg?v=1788616301",
    "color_bar_bg": "bg=#A6192E;border=#FFC72C",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#A6192E",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "September 2, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 3, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 15, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 3, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "All students will pick up their packages from the Residence Life office located in the Stevenson building. Students notified via school email.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "ohio": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Ohio University",
    "sponsor_school": "Ohio University",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#00694e",
    "internal_order_code": "oh-ohio",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/ohio-campus.jpg?v=1785183264",
    "color_bar_bg": "bg=#00694E;border=#024230",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#00694E",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 19, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Adams Hall (East)", "Biddle Hall (East)", "Boyd Hall (West)", "Bromley Hall (West)", "Brown Hall (South)", "Bryan Hall (East)", "Bush Hall (East)", "Carr Hall (South)", "Convocation Center (West)", "Crawford Hall (South)", "Dougan House (East)", "Ewing House (South)", "Four University Terrace (East)", "Gamertsfelder Hall (East)", "Hoover House (East)", "James Hall (West)", "Jefferson Hall (East)", "Johnson Hall (East)", "Lincoln Hall (East)", "Luchs Hall (South)", "Mackinnon Hall (South)", "McDavis Hall (South)", "Perkins Hall (East)", "Pickering Hall (South)", "Read Hall (East)", "River Gate", "River Park Building 34", "River Park Building 35", "River Park Building 36", "River Park Building 37", "River Park Building 38", "Ryors Hall (West)", "Sargent Hall (West)", "Shively Hall (East)", "Sowle Hall (South)", "Tanaka Hall (East)", "Tiffin Hall (East)", "Treudley Hall (West)", "True House (East)", "Voigt Hall (East)", "Washington Hall (East)", "Wilson Hall (West)", "Wray House (East)"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "okcu": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Oklahoma City University",
    "sponsor_school": "Oklahoma City University",
    "sponsor_org": "the Housing and Residence Life Department",
    "primary_color": "#00669b",
    "internal_order_code": "ok-okcu",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/okcu-campus.jpg?v=1788653030",
    "color_bar_bg": "bg=#ffffff;border=#000000",
    "color_bar_text": "#000000",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#00669b",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 26, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will pick up their package at the Residence Hall Front Desk.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "oneonta": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "SUNY Oneonta",
    "sponsor_school": "SUNY Oneonta",
    "sponsor_org": "the Resident Student Organization",
    "primary_color": "#CC0025",
    "internal_order_code": "ny-oneonta",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/oneonta-campus.jpg?v=1785122540",
    "color_bar_bg": "bg=#ffffff;border=#000000",
    "color_bar_text": "#CC0025",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#CC0025",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "bg=#515151",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 7, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 15, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 10, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will pick up their package at Dragon Express Mail Services.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "pace": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Pace University-Westchester",
    "sponsor_school": "Pace University-Westchester",
    "sponsor_org": "the Office of Residential Life",
    "primary_color": "#002D73",
    "internal_order_code": "ny-pace",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/pace-campus.jpg?v=1789766888",
    "color_bar_bg": "",
    "color_bar_text": "#FFB81A",
    "color_hero_text": "#FFB81A",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#FFB81A",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#FFB81A;btn1_text=#002D73",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 28, 2026",
    "kd_welcome_availability": "September 7, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 3, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 15, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 27, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "All packages go to the mailroom and students will get an email to pick them up.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "pacenyc": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Pace University-New York City",
    "sponsor_school": "Pace University-New York City",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#002D73",
    "internal_order_code": "ny-pacenyc",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/pacenyc-campus.jpg?v=1785182553",
    "color_bar_bg": "",
    "color_bar_text": "#FFB81A",
    "color_hero_text": "#FFB81A",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#FFB81A",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#FFB81A;btn1_text=#002D73",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 28, 2026",
    "kd_welcome_availability": "September 7, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 1, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 15, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 27, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "pepperdine": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Pepperdine University",
    "sponsor_school": "Pepperdine University",
    "sponsor_org": "the Student Alumni Organization",
    "primary_color": "#1e2859",
    "internal_order_code": "ca-pepperdine",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/pepperdine-campus.jpg?v=1785467267",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "#e65526",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#e65526;btn2_bg=#e65526",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 7, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 11, 2026",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 19, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students pick up their packages at the mailroom (through the usual package process).", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "pittstate": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Pitt State",
    "sponsor_school": "Pittsburg State University",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#CC0C2F",
    "internal_order_code": "ks-pittstate",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/pittstate-campus.jpg?v=1784946809",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#FCD116;btn1_text=#000000;btn2_bg=#FCD116;btn2_text=#000000;badge_bg=#000000",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 24, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 3, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will be text notified to pick up packages at the Housing Office in Horace Mann from 8-4.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "plymouth": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Plymouth State University",
    "sponsor_school": "Plymouth State University",
    "sponsor_org": "Residential Life",
    "primary_color": "#135841",
    "internal_order_code": "nh-plymouth",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/plymouth-campus.jpg?v=1789416545",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#A0B8B0",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 28, 2026",
    "kd_welcome_availability": "September 7, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 7, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 15, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 27, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students have been notified to pick up packages at Resident Life & Dining Office, 201-A Speare, Monday thru Friday, from 9am to 430pm.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "psu": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Penn State",
    "sponsor_school": "Penn State",
    "sponsor_org": "the National Residence Hall Honorary Nittany Chapter",
    "primary_color": "#001E44",
    "internal_order_code": "pa-psu",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/psu-campus.jpg?v=1788716775",
    "color_bar_bg": "bg=#001E44",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#96BEE6",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#1E407C;btn2_bg=#001E44",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 4, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 23, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "radford": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": false, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": false, "care_off_springfinals": true,
    "name": "Radford University",
    "sponsor_school": "Radford University",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#c2011b",
    "internal_order_code": "va-radford",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/radford-campus.jpg?v=1788978826",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#c2011b",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn2_bg=#003c71",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "",
    "kd_halloween_availability": "",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 1, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "",
    "kd_springsurprise_availability": "",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 26, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students have been texted to pick up at Office of Housing & Residential Life located on the second floor of Heth Hall, Room 226 between 9am & 4pm.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "rice": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Rice University",
    "sponsor_school": "Rice University",
    "sponsor_org": "the Student Success Initiative and First Year Programs",
    "primary_color": "#00205B",
    "internal_order_code": "tx-rice",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/rice-campus.jpg?v=1788918104",
    "color_bar_bg": "bg=#ffffff;border=#00205B",
    "color_bar_text": "#00205B",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#0a509e",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#0a509e;btn2_bg=#0a509e;badge_bg=#0a509e",
    "color_fulfillment": "bg=#0a509e",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 17, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students have been directed to pick up at Rice Memorial Center (RMC). Offices are located in the basement of the Rice Memorial Center across from the PUB. Please email Ahjah Green (ag258@rice.edu) or Tamara Davis (td83@rice.edu) regarding when you are coming to pick up so we can make sure we are available during that time. (Normal hours 10-4)", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Baker", "Brown", "Chao", "Duncan", "Hanszen", "Jones", "Lovett", "Martel", "McMurty", "Richardson", "Wiess", "Will Rice", "Unknown"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "sdstate": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "South Dakota State University",
    "sponsor_school": "South Dakota State University",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#0033A0",
    "internal_order_code": "sd-sdstate",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/sdstate-campus.jpg?v=1788747537",
    "color_bar_bg": "bg=#0033A0;border=#FFD100",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#FFD100",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#FFD100;btn1_text=#000000;btn2_bg=#0033A0;",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 2, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 26, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Pickup is at the residence hall front desk. Students will receive an email from the front desk when their package is ready.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Abbot", "Ben Reifel", "Binnewies", "Brown", "Caldwell", "Hansen", "Honors", "Matthews", "Meadows North", "Meadows South", "Pierson", "Schultz", "Spencer", "Thorne", "Waneta", "Young", "Unknown"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "semo": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": false,
    "care_on_springsurprise": false, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": false,
    "care_off_springsurprise": false, "care_off_springfinals": true,
    "name": "Southeast Missouri State University",
    "sponsor_school": "Southeast Missouri State University",
    "sponsor_org": "the Office of Residence Life",
    "primary_color": "#C8102E",
    "internal_order_code": "mo-semo",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/semo-campus.jpg?v=1788374246",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#212121",
    "color_heading_care_top": "#C8102E",
    "color_heading_care_bottom": "#212121",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "",
    "kd_halloween_availability": "",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 7, 2026",
    "kd_valentines_deadline": "",
    "kd_valentines_availability": "",
    "kd_springsurprise_deadline": "",
    "kd_springsurprise_availability": "",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 3, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will pick up their package in their residence hall.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "sewanee": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": false, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": false, "care_off_springfinals": true,
    "name": "University of the South",
    "sponsor_school": "the University of the South",
    "sponsor_org": "the Residential Life Office",
    "primary_color": "#582C83",
    "internal_order_code": "tn-sewanee",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/sewanee-campus.jpg?v=1788816681",
    "color_bar_bg": "bg=#582C83;border=#000000",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#FFB81C",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#FFB81C;btn1_text=#582C83",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "September 1, 2026",
    "kd_halloween_deadline": "",
    "kd_halloween_availability": "",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 4, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "",
    "kd_springsurprise_availability": "",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 30, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students are emailed and texted to pick up their packages.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Box #"
  },
  "ship": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Shippensburg University",
    "sponsor_school": "Shippensburg University",
    "sponsor_org": "Student Services",
    "primary_color": "#0C2340",
    "internal_order_code": "pa-ship",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/ship-campus.jpg?v=1788724161",
    "color_bar_bg": "border=#E4002B",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#005CB9",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#005CB9;btn2_bg=#005CB9",
    "color_fulfillment": "bg=#005CB9",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 26, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students receive notification to pick up their package at the campus UPS store.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "siue": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Southern Illinois University Edwardsville",
    "sponsor_school": "Southern Illinois University Edwardsville",
    "sponsor_org": "the Residence Housing Association",
    "primary_color": "#e5182d",
    "internal_order_code": "il-siue",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/siue-campus.jpg?v=1784928367",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#e5182d",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "bg=#cdd0cf",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 7, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 26, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will pick up their package at their Residence Hall Front Desk.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Bluff Hall", "Cougar Village Commons", "Evergreen Hall", "Prairie Hall", "Woodland Hall", "Unknown"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "sju": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": false,
    "care_on_springsurprise": false, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": false,
    "care_off_springsurprise": false, "care_off_springfinals": true,
    "name": "Saint Joseph's University",
    "sponsor_school": "Saint Joseph's University",
    "sponsor_org": "the American Marketing Association",
    "primary_color": "#9e1b32",
    "internal_order_code": "pa-sju",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/sju-campus.png?v=1789680931",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#9e1b32",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#6c6f70",
    "color_fulfillment": "bg=#6c6f70",
    "kd_welcome_deadline": "",
    "kd_welcome_availability": "",
    "kd_halloween_deadline": "",
    "kd_halloween_availability": "",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 3, 2026",
    "kd_valentines_deadline": "",
    "kd_valentines_availability": "",
    "kd_springsurprise_deadline": "",
    "kd_springsurprise_availability": "",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 29, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will be notified by school email with dates and times they can pick up their package in the Marketing Dept. in Mandeville 249.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "slu": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Saint Louis University",
    "sponsor_school": "Saint Louis University",
    "sponsor_org": "the Office of Parent and Family Engagement",
    "primary_color": "#003DA5",
    "internal_order_code": "mo-slu",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/slu-campus.jpg?v=1786071744",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "",
    "color_buttons": "",
    "color_fulfillment": "bg=#e3deca;text=#000000",
    "kd_welcome_deadline": "September 11, 2026",
    "kd_welcome_availability": "September 20, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 27, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "southalabama": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "University of South Alabama",
    "sponsor_school": "the University of South Alabama",
    "sponsor_org": "the Housing Department",
    "primary_color": "#00205B",
    "internal_order_code": "al-southalabama",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/southalabama-campus.jpg?v=1784497942",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#bf0d3e;btn2_bg=#bf0d3e",
    "color_fulfillment": "bg=#bf0d3e",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 25, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 26, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will be notified to pickup their packages at the students' Community Desk when they are available.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "southeasttech": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": false, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": false, "care_off_springfinals": true,
    "name": "Southeast Technical College",
    "sponsor_school": "Southeast Technical College",
    "sponsor_org": "the Housing Department",
    "primary_color": "#004987",
    "internal_order_code": "sd-southeasttech",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/southeasttech-campus.jpg?v=1788801676",
    "color_bar_bg": "bg=#40b4e5;border=#000000",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#40b4e5",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 24, 2026",
    "kd_halloween_deadline": "",
    "kd_halloween_availability": "",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "",
    "kd_springsurprise_availability": "",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 26, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "stevens": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Stevens Institute of Technology",
    "sponsor_school": "Stevens Institute of Technology",
    "sponsor_org": "the Office of Residential Education",
    "primary_color": "#9d1535",
    "internal_order_code": "nj-stevens",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/stevens-campus.jpg?v=1789424401",
    "color_bar_bg": "border=#949594",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#949594",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "bg=#949594",
    "kd_welcome_deadline": "August 28, 2026",
    "kd_welcome_availability": "September 8, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 8, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 30, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["1036 Park Ave", "Castle Point Hall", "Davis Hall", "Humphreys", "Jonas", "Palmer", "River Terrace Stes", "UCC University Towers", "Unknown"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "stkate": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "St. Catherine University",
    "sponsor_school": "St. Catherine University",
    "sponsor_org": "the Campus Life Department",
    "primary_color": "#502D7F",
    "internal_order_code": "mn-stkate",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/stkate-campus.jpg?v=1789398928",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#F4DA40",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#F4DA40;btn1_text=#502D7F",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 28, 2026",
    "kd_welcome_availability": "September 7, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 7, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 26, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students are notified with package pickup directions.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "stonybrook": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Stony Brook University",
    "sponsor_school": "Stony Brook University",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#990000",
    "internal_order_code": "ny-stonybrook",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/stonybrook-campus.jpg?v=1788577814",
    "color_bar_bg": "bg=#ffffff;border=#000000",
    "color_bar_text": "#990000",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#990000",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 1, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 3, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "tiffin": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Tiffin University",
    "sponsor_school": "Tiffin University",
    "sponsor_org": "the Tiffin Hall and House Association",
    "primary_color": "#154734",
    "internal_order_code": "oh-tiffin",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/tiffin-campus.jpg?v=1788634131",
    "color_bar_bg": "bg=#154734;border=#daaa00",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#daaa00",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#daaa00",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 11, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 19, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will be instructed (via school email) to pick up their packages in the Student Development and Transformation (formally Student Affairs) hallway. Liz's office is located here, which has information about pick up time so they know who to ask. Also front desk attendant will assist in the pickups.", "section": "which has information about pick up time so they know who to ask. Also front desk attendant will assist in the pickups."}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "towson": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Towson University",
    "sponsor_school": "Towson University",
    "sponsor_org": "the National Residence Hall Honorary",
    "primary_color": "#FFBB00",
    "internal_order_code": "md-towson",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/towson-campus.jpg?v=1788354380",
    "color_bar_bg": "bg=#ffffff;border=#000000",
    "color_bar_text": "#000000",
    "color_hero_text": "#000000",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#FFBB00",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_text=#000000;btn2_text=#000000;badge_bg=#000000;badge_text=#FFBB00",
    "color_fulfillment": "text=#000000",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10,2026",
    "kd_halloween_availability": "October 29,2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 1, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 5, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "The student will pickup their package at the Community Center desk from 7:00 am to 7:00 pm. They will need to show their One Card for ID.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "truman": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Truman",
    "sponsor_school": "Truman State University",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#510C76",
    "internal_order_code": "mo-truman",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/truman-campus.jpg?v=1787364754",
    "color_bar_bg": "bg=#ffffff;border=#510C76",
    "color_bar_text": "#510C76",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 24, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 26, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will pick up their Care Package at their Residence Hall's Front Desk. They will be notified via school email.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "ttu": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Texas Tech University",
    "sponsor_school": "Texas Tech University",
    "sponsor_org": "Raiders Helping Others",
    "primary_color": "#cc0000",
    "internal_order_code": "tx-ttu",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/ttu-campus.jpg?v=1784515172",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#cc0000",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 2, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 29, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will pick up their Care Package at their Residence Hall's Post Office. Residents will receive an email with a QR code to present to hall staff to pick up their package.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "ua": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "SWAKU in Partnership with The University of Alabama National Alumni Association",
    "sponsor_school": "the University of Alabama",
    "sponsor_org": "the National Alumni Association",
    "primary_color": "#9E1B32",
    "internal_order_code": "al-ua",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/ua-campus.jpg?v=1787959762",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 26, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2026",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 26, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "true",
    "room_label": "Mail Stop Code (MSC)"
  },
  "uca": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "University of Central Arkansas",
    "sponsor_school": "the University of Central Arkansas",
    "sponsor_org": "Resident Housing Association",
    "primary_color": "#582C83",
    "internal_order_code": "ar-uca",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/uca-campus.jpg?v=1784833488",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 27, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 15, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 16, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will be notified via school email to pick up their package at the RHA Office in Bernard Hall, Room 203.", "section": "Room 203."}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "ucdavis": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "UC Davis Aggie Parent & Family Association",
    "sponsor_school": "UC Davis",
    "sponsor_org": "the UC Davis Aggie Parent & Family Association",
    "primary_color": "#022851",
    "internal_order_code": "ca-ucdavis",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/ucdavis-campus.jpg?v=1786028762",
    "color_bar_bg": "",
    "color_bar_text": "#FFBF00",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#FFBF00",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#FFBF00;btn1_text=#022851",
    "color_fulfillment": "bg=#FFBF00;text=#000000",
    "kd_welcome_deadline": "September 15, 2026",
    "kd_welcome_availability": "September 28, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 15, 2027",
    "kd_springfinals_deadline": "May 15, 2027",
    "kd_springfinals_availability": "May 28, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will be notified via email to pick up their package in their hall's mailroom.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Alder Hall", "Bixby Hall", "Campbell Hall", "Campo Hall", "Cottonwood Hall", "Currant Hall", "Gilmore Hall", "Hawthorn Hall", "Indio Hall", "Kearney Hall", "Laben Hall", "Live Oak Hall", "Madrone Hall", "Mahogany Hall", "Malcolm Hall", "Miller Hall", "Nova Hall", "Paloma Hall", "Pine Hall", "Potter Hall", "Redwood Hall", "Rienda Hall", "Ryerson Hall", "Scrub Oak Hall", "Sequoia Hall", "Sereno Hall", "Shasta", "Tahoe Hall", "Talara Hall", "Thompson Hall", "Wall Hall", "Yosemite", "Unknown"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "ucmo": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "University of Central Missouri",
    "sponsor_school": "the University of Central Missouri",
    "sponsor_org": "the United Student Housing Association",
    "primary_color": "#cf202e",
    "internal_order_code": "mo-ucmo",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/ucmo-campus.jpg?v=1785018052",
    "color_bar_bg": "bg=#ffffff;border=#000000",
    "color_bar_text": "#cf202e",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#cf202e",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "badge_bg=#000000",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 24, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 26, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students pick up their packages in Ellis Complex at the University Housing Office. They will be notified by student email.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "ucr": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "UC Riverside",
    "sponsor_school": "UC Riverside",
    "sponsor_org": "the Student Alumni Association",
    "primary_color": "#003da5",
    "internal_order_code": "ca-ucr",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/ucr-campus.jpg?v=1786062749",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#ffb81c;btn1_text=#000000",
    "color_fulfillment": "bg=#ffb81c;text=#000000",
    "kd_welcome_deadline": "September 15, 2026",
    "kd_welcome_availability": "September 28, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 15, 2027",
    "kd_springfinals_deadline": "May 15, 2027",
    "kd_springfinals_availability": "May 31, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students pick up their packages in the Resident Service Office.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Aberdeen-Inverness", "Dundee", "Glen Mor", "Lothian", "North District 2", "Pentland Hills", "Unknown"],
    "room_required": "false",
    "room_label": "Mail Box #"
  },
  "uic": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "University of Illinois Chicago",
    "sponsor_school": "the University of Illinois Chicago",
    "sponsor_org": "New Student and Family Programs",
    "primary_color": "#d50032",
    "internal_order_code": "il-uic",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/uic-campus.jpg?v=1788290311",
    "color_bar_bg": "bg=#ffffff;border=#001e62",
    "color_bar_text": "#d50032",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#d50032",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn2_bg=#001e62",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 15, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 26, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will be emailed to pick up package at New Student & Family Programs Office, Room 251, Student Center East Building,*Across from the Commuter Center, during business hours.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "uidaho": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "University of Idaho",
    "sponsor_school": "the University of Idaho",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#F1B300",
    "internal_order_code": "id-uidaho",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/uidaho-campus.jpg?v=1784862448",
    "color_bar_bg": "",
    "color_bar_text": "#000000",
    "color_hero_text": "#000000",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#F1B300",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_text=#000000;btn2_text=#000000;badge_text=#000000",
    "color_fulfillment": "text=#000000",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 7, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 3, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Packages can be picked-up at the LLC Information Desk (901 Paradise Creek St.), which is open 24 hours each day. Students will be notified by student email.", "section": "which is open 24 hours each day. Students will be notified by student email."}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "uiowa": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "University of Iowa",
    "sponsor_school": "the University of Iowa",
    "sponsor_org": "the Residence Hall Activities Board",
    "primary_color": "#FFCD00",
    "internal_order_code": "ia-uiowa",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/uiowa-campus.jpg?v=1784857772",
    "color_bar_bg": "bg=#000000;border=#000000",
    "color_bar_text": "#FFCD00",
    "color_hero_text": "#000000",
    "color_heading_room": "#FFCD00",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#FFCD00",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_text=#000000;btn2_text=#000000;;badge_bg=#000000;badge_text=#FFCD00",
    "color_fulfillment": "text=#000000",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "September 3, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 7, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 3, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students are emailed to pick up their packages at their residence hall front desk.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "ulm": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": false, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": false, "care_off_springfinals": true,
    "name": "University of Louisiana Monroe",
    "sponsor_school": "the University of Louisiana Monroe",
    "sponsor_org": "the Residential Life Office",
    "primary_color": "#840029",
    "internal_order_code": "la-ulm",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/ulm-campus.jpg?v=1784948749",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#fdb913",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#fdb913;btn1_text=#840029;btn2_bg=#fdb913;btn2_text=#840029",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 24, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 24, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "",
    "kd_springsurprise_availability": "",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 28, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students are emailed to pick up packages  from the Residential Life main office located behind the Starbucks in University Suites. Students will need to show their ULM Student ID card to pick up their care package.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "umbc": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "UMBC",
    "sponsor_school": "the University of Maryland, Baltimore County",
    "sponsor_org": "the Resident Student Association",
    "primary_color": "#fdb515",
    "internal_order_code": "md-umbc",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/umbc-campus.jpg?v=1788371634",
    "color_bar_bg": "bg=#ffffff;border=#000000",
    "color_bar_text": "#000000",
    "color_hero_text": "#000000",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#fdb515",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_text=#000000;btn2_text=#000000;badge_text=#000000",
    "color_fulfillment": "text=#000000",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10,2026",
    "kd_halloween_availability": "October 29,2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 3, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 5, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will pick up their Care Package at their Residence Hall's Front Desk. They will be notified via school email.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "umd": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "University of Maryland",
    "sponsor_school": "the University of Maryland",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#e21833",
    "internal_order_code": "md-umd",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/umd-campus.jpg?v=1789325548",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#e21833",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 28, 2026",
    "kd_welcome_availability": "September 7, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 4, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 5, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "uml": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "UMass Lowell",
    "sponsor_school": "UMass Lowell",
    "sponsor_org": "the Office of Residence Life",
    "primary_color": "#1257D1",
    "internal_order_code": "ma-uml",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/uml-campus.jpg?v=1789160319",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 28, 2026",
    "kd_welcome_availability": "September 8, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 4, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 23, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students are texted to pick up their package at their building's staff office (from 7 pm-10 pm).", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "umsl": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": false, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": false, "care_off_springfinals": true,
    "name": "University of Missouri-St Louis",
    "sponsor_school": "the University of Missouri-St Louis",
    "sponsor_org": "the Residential Housing Association",
    "primary_color": "#ba0c2f",
    "internal_order_code": "mo-umsl",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/umsl-campus.jpg?v=1789673452",
    "color_bar_bg": "bg=#ffffff;border=#000000",
    "color_bar_text": "#ba0c2f",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#eaab00",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#eaab00;btn1_text=#000000",
    "color_fulfillment": "bg=#5d666f",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "",
    "kd_halloween_availability": "",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 7, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "",
    "kd_springsurprise_availability": "",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 3, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will be emailed to pick up their packages.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "unc": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "UNC-Chapel Hill",
    "sponsor_school": "the University of North Carolina at Chapel Hill",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#4B9CD3",
    "internal_order_code": "nc-unc",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/unc-campus.jpg?v=1787796237",
    "color_bar_bg": "",
    "color_bar_text": "#13294B",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#4B9CD3",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn2_bg=#13294B",
    "color_fulfillment": "bg=#13294B",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 24, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 24, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 20, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will be notified via school email to pick up their care package at their designated Pickup Center.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "unco": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "University of Northern Colorado",
    "sponsor_school": "the University of Northern Colorado",
    "sponsor_org": "the Residence Hall Association and Housing and Residential Education",
    "primary_color": "#013C65",
    "internal_order_code": "co-unco",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/unco-campus.jpg?v=1784847418",
    "color_bar_bg": "bg=#ffffff;border=#013C65",
    "color_bar_text": "#013C65",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#F6B000",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#F6B000;btn1_text=#013C65;btn2_bg=#013C65",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 27, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "und": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "University of North Dakota",
    "sponsor_school": "the University of North Dakota",
    "sponsor_org": "the Housing and Residence Life Office",
    "primary_color": "#009A44",
    "internal_order_code": "nd-und",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/und-campus.jpg?v=1788491283",
    "color_bar_bg": "bg=#000000;border=#009A44",
    "color_bar_text": "009A44",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "009A44",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 4, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 3, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will pick up their package at the Wilkerson Commons Service Center.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "unk": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "UNK",
    "sponsor_school": "the University of Nebraska at Kearney",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#004D86",
    "internal_order_code": "ne-unk",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/unk-campus.jpg?v=1788545458",
    "color_bar_bg": "border=#E4A115",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#E4A115",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 7, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 26, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students are texted to pick up their package at Mantor Hall (open Mon thru Friday from 10-10 and Sat & Sun from 7pm to 10pm.)", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Antelope Hall", "Antelope Hall", "Armstong Hall", "Centennial Towers East", "Centennial Towers West", "Mantor Hall", "Martin Hall", "Mens Hall", "Nester Hall North", "Nester Hall South", "Randall Hall", "Village Flats Apartments", "Unknown"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "unomaha": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "UNO",
    "sponsor_school": "the University of Nebraska at Omaha",
    "sponsor_org": "Housing and Residence Life",
    "primary_color": "#000000",
    "internal_order_code": "ne-unomaha",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/unomaha-campus.jpg?v=1788547929",
    "color_bar_bg": "bg=#000000;border=#D71920",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "#D71920",
    "color_heading_care_bottom": "",
    "color_buttons": "btn1_bg=#D71920;btn2_bg=#D71920",
    "color_fulfillment": "bg=#bcbbba;text=#000000",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 4, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 23, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students are notified by email to pick up their package at the Front Desk of their Village.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Maverick Village", "University Village", "Unknown"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "uoregon": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "University of Oregon",
    "sponsor_school": "the University of Oregon",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#007030",
    "internal_order_code": "or-uoregon",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/uoregon-campus.jpg?v=1786115705",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "#FEE11A",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "#007030",
    "color_heading_care_bottom": "",
    "color_buttons": "",
    "color_fulfillment": "bg=#FEE11A;text=#000000",
    "kd_welcome_deadline": "September 15, 2026",
    "kd_welcome_availability": "October 5, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 15, 2027",
    "kd_springfinals_deadline": "May 15, 2027",
    "kd_springfinals_availability": "May 31, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Barnhart", "Carson", "Earl", "Global Scholars", "Hamilton", "Justice Bean", "Kalapuya", "Living Learning Center", "New Residence", "Riley", "Unthank", "Yasui", "Unknown"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "uscupstate": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": false, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": false, "care_off_springfinals": true,
    "name": "USC Upstate",
    "sponsor_school": "the University of South Carolina Upstate",
    "sponsor_org": "the Association of Residential Communities and Residence Hall Association",
    "primary_color": "#00833e",
    "internal_order_code": "sc-uscupstate",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/uscupstate-campus.jpg?v=1787951974",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#00833e",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "badge_bg=#000000",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 25, 2026",
    "kd_halloween_deadline": "",
    "kd_halloween_availability": "",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 2, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "",
    "kd_springsurprise_availability": "",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 22, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students are notified to pick up their packages in 13A Palmetto House at the Res Life Office.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "usm": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Southern Miss",
    "sponsor_school": "the University of Southern Mississippi",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#000000",
    "internal_order_code": "ms-usm",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/usm-campus.jpg?v=1788381663",
    "color_bar_bg": "bg=#000000;border=#000000",
    "color_bar_text": "#FFD046",
    "color_hero_text": "#000000",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#FFD046",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#FFD046;btn1_text=#000000;btn2_bg=#FFD046;btn2_text=#000000;badge_bg=#000000;badge_text=#FFD046",
    "color_fulfillment": "bg=#FFD046;text=#000000",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 3, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students have been notified to pick up their packages in the RHA Center between 9am and 7pm Monday thru Friday.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "usu": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Utah State University",
    "sponsor_school": "Utah State University",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#0F2439",
    "internal_order_code": "ut-usu",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/usu-campus.jpg?v=1785275832",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "#288DC2",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#288DC2",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#288DC2;btn2_bg=#288DC2",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 28, 2026",
    "kd_welcome_availability": "September 7, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 7, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 21, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students are notified with package pickup directions.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Blue Square Apts", "Bullen Hall", "Canyon Crest Suites", "Central Suites", "Davis Hall (SLC)", "Jones Hall (SLC)", "Living Learning Community", "Merrill Hall", "Morgan Hall (SLC)", "Mtn View Tower", "Rich Hall (SLC)", "Richards Hall", "Ridge Point Hall", "San Juan Hall(SLC)", "Snow Hall (SLC)", "Summit Hall (SLC)", "Wasatch Hall (SLC)"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "utk": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "University of Tennessee",
    "sponsor_school": "the University of Tennessee, Knoxville",
    "sponsor_org": "the United Residence Halls Council",
    "primary_color": "#FF8200",
    "internal_order_code": "tn-utk",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/utk-campus.jpg?v=1785207380",
    "color_bar_bg": "bg=#ffffff;border=#4B4B4B",
    "color_bar_text": "#FF8200",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#4B4B4B",
    "color_heading_care_top": "#FF8200",
    "color_heading_care_bottom": "#4B4B4B",
    "color_buttons": "badge_bg=#4B4B4B",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 24, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 24, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2026",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 29, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Pickup is at the Residence Hall Front Desk. Students will receive an email from the Front Desk when their packages are ready.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "uwec": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "UW-Eau Claire",
    "sponsor_school": "the University of Wisconsin-Eau Claire",
    "sponsor_org": "the Residence Hall Association & the Department of Housing & Residence Life",
    "primary_color": "#2C3C88",
    "internal_order_code": "wi-uwec",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/uwec-campus.jpg?v=1789693996",
    "color_bar_bg": "",
    "color_bar_text": "#EAA610",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#EAA610",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#EAA610;btn1_text=#000000;btn2_bg=#EAA610;btn2_text=#000000",
    "color_fulfillment": "",
    "kd_welcome_deadline": "",
    "kd_welcome_availability": "",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 8, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 3, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students have been emailed & texted to pick up their packages in the small conference room near the front desk in Towers. They will need their Blugold IDs.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "uwf": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "University of West Florida",
    "sponsor_school": "the University of West Florida",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#00A346",
    "internal_order_code": "fl-uwf",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/uwf-campus.jpg?v=1789784473",
    "color_bar_bg": "bg=#ffffff;border=#00205B",
    "color_bar_text": "#00A346",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#00A346",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn2_bg=#00205B",
    "color_fulfillment": "bg=#00205B",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 28, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 19, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students are emailed and texted to pick up their packages.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "uwgb": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "UW-Green Bay",
    "sponsor_school": "the University of Wisconsin-Green Bay",
    "sponsor_org": "the Office of Housing & Residential Education",
    "primary_color": "#0F5640",
    "internal_order_code": "wi-uwgb",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/uwgb-campus.jpg?v=1789701753",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#1BA72E",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#0F5640;btn2_bg=#289A8F",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 28, 2026",
    "kd_welcome_availability": "September 9, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 9, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 3, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will be notified to pick up their package in Housing & Residential Education.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "uwm": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "UW-Milwaukee",
    "sponsor_school": "the University of Wisconsin-Milwaukee",
    "sponsor_org": "the Student Housing Administrative Council",
    "primary_color": "#ffbd00",
    "internal_order_code": "wi-uwm",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/uwm-campus.jpg?v=1785293251",
    "color_bar_bg": "bg=#ffffff;border=#000000",
    "color_bar_text": "#000000",
    "color_hero_text": "#000000",
    "color_heading_room": "#ffbd00",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#ffbd00",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_text=#000000;btn2_text=#000000;badge_bg=#333333;badge_text=#ffbd00",
    "color_fulfillment": "bg=#333333",
    "kd_welcome_deadline": "August 28, 2026",
    "kd_welcome_availability": "September 9, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 8, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 15, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 6, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will pick up their Care Package at their Residence Hall's Mail Room. They will be notified via school email.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Cambridge Commons", "Kenilworth Square", "Riverview", "Sandburg", "Unknown"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "uwrf": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "UW-River Falls",
    "sponsor_school": "the University of Wisconsin-River Falls",
    "sponsor_org": "the Student Housing Administrative Council",
    "primary_color": "#D31145",
    "internal_order_code": "wi-uwrf",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/uwrf-campus.jpg?v=1789762970",
    "color_bar_bg": "bg=#ffffff;border=#000000",
    "color_bar_text": "#D31145",
    "color_hero_text": "",
    "color_heading_room": "#D31145",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#D31145",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 28, 2026",
    "kd_welcome_availability": "September 9, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 10, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 3, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will be notified by school email when their packages are available for pickup in the Resident Life Office (Hathorn Hall).", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "uwsp": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": false,
    "care_on_springsurprise": false, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": false,
    "care_off_springsurprise": false, "care_off_springfinals": true,
    "name": "UW-Stevens Point",
    "sponsor_school": "the University of Wisconsin-Stevens Point",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#512698",
    "internal_order_code": "wi-uwsp",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/uwsp-campus.png?v=1789766942",
    "color_bar_bg": "bg=#ffc82e",
    "color_bar_text": "#512698",
    "color_hero_text": "#ffc82e",
    "color_heading_room": "#ffc82e",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#ffc82e",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#ffc82e;btn1_text=#512698;btn2_bg=#512698;btn2_text=#ffc82e",
    "color_fulfillment": "text=#ffc82e",
    "kd_welcome_deadline": "August 28, 2026",
    "kd_welcome_availability": "September 9, 2026",
    "kd_halloween_deadline": "",
    "kd_halloween_availability": "",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 4, 2026",
    "kd_valentines_deadline": "",
    "kd_valentines_availability": "",
    "kd_springsurprise_deadline": "",
    "kd_springsurprise_availability": "",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 8, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will be notified to pick up their care package at their residence hall front desk.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "westfield": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Westfield State University",
    "sponsor_school": "Westfield State University",
    "sponsor_org": "the Office of Residence Life",
    "primary_color": "#232C64",
    "internal_order_code": "ma-westfield",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/westfield-campus.jpg?v=1784951179",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#d98e04",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#d98e04;btn2_bg=#d98e04",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 28, 2026",
    "kd_welcome_availability": "September 10, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 8, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 27, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Student will pick up their package at the Student Mail Center.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "wfu": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Wake Forest University",
    "sponsor_school": "Wake Forest University",
    "sponsor_org": "Residence Life and Housing",
    "primary_color": "#9E7E38",
    "internal_order_code": "nc-wfu",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/wfu-campus.jpg?v=1788458549",
    "color_bar_bg": "bg=#000000;border=#9E7E38",
    "color_bar_text": "#9E7E38",
    "color_hero_text": "#000000",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#9E7E38",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "badge_bg=#000000",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 1, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 20, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Student will pick up their package at the Student Mail Center.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Box #"
  },
  "wichita": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Wichita State University",
    "sponsor_school": "Wichita State University",
    "sponsor_org": "the Housing & Residence Life Department",
    "primary_color": "#000000",
    "internal_order_code": "ks-wichita",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/wichita-campus.jpg?v=1787257883",
    "color_bar_bg": "#3b3b3b",
    "color_bar_text": "#ffffff",
    "color_hero_text": "#3b3b3b",
    "color_heading_room": "#FFDB00",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#FFDB00",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#FFDB00;btn1_text=#000000;btn2_bg=#FFDB00;btn2_text=#000000;badge_bg=#000000",
    "color_fulfillment": "bg=#FFDB00;text=#000000",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 24, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 3, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students pick up at Residence Hall front desk and are notified through the regular package system.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "winthrop": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Winthrop University",
    "sponsor_school": "Winthrop University",
    "sponsor_org": "the Residential Student Association",
    "primary_color": "#6b0d0e",
    "internal_order_code": "sc-winthrop",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/winthrop-campus.jpg?v=1790536610",
    "color_bar_bg": "border=#f8c23a",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#f8c23a",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#f8c23a;btn1_text=#000000",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 2, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 19, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "wittenberg": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Wittenberg University",
    "sponsor_school": "Wittenberg University",
    "sponsor_org": "the Office of Residence Life",
    "primary_color": "#990000",
    "internal_order_code": "oh-wittenberg",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/wittenberg-campus.jpg?v=1788639150",
    "color_bar_bg": "bg=#990000",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#990000",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 24, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 27, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will be notified to pick up their care package from the mailroom.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "wne": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Western New England University",
    "sponsor_school": "Western New England University",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#002d72",
    "internal_order_code": "ma-wne",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/wne-campus.jpg?v=1789175816",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#F2A900",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#F2A900;btn1_text=#000000;btn2_bg=#F2A900;btn2_text=#000000",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 28, 2026",
    "kd_welcome_availability": "September 7, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 4, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "May 3, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students are notified to pick up their packages in the Office of Residence life located on the 2nd floor of the Campus Center.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Box #"
  },
  "wooster": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Wooster",
    "sponsor_school": "The College of Wooster",
    "sponsor_org": "the Mayer Bookstore",
    "primary_color": "#F7BD00",
    "internal_order_code": "oh-wooster",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/wooster-campus.jpg?v=1785185055",
    "color_bar_bg": "bg=#000000;border=#000000",
    "color_bar_text": "#F7BD00",
    "color_hero_text": "#000000",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#F7BD00",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_text=#000000;;btn2_text=#000000;badge_bg=#000000;badge_text=#F7BD00",
    "color_fulfillment": "text=#000000",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 26, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 28, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will pick up their packages at the mailroom.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "wpi": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Worcester Polytechnic Institute",
    "sponsor_school": "Worcester Polytechnic Institute",
    "sponsor_org": "the Housing and Residential Experience Center",
    "primary_color": "#AC2B37",
    "internal_order_code": "ma-wpi",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/wpi-campus.png?v=1784426255",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#AC2B37",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "badge_bg=#000000",
    "color_fulfillment": "bg=#A9B0B7;text=#000000",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 27, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 10, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 28, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "WPI Mailbox #"
  },
  "wright": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": false, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": false, "care_off_springfinals": true,
    "name": "Wright State University",
    "sponsor_school": "Wright State University",
    "sponsor_org": "the Residential Community Association",
    "primary_color": "#046A38",
    "internal_order_code": "oh-wright",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/wright-campus.jpg?v=1788641473",
    "color_bar_bg": "bg=#046A38",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#CBA052",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#CBA052",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "",
    "kd_springsurprise_availability": "",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 19, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "wssu": {
    "care_on": true, "care_off": true,
    "room_on": true, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "WSSU",
    "sponsor_school": "Winston-Salem State University",
    "sponsor_org": "the Residence Hall Association",
    "primary_color": "#c8102e",
    "internal_order_code": "nc-wssu",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/wssu-campus.jpg?v=1787799765",
    "color_bar_bg": "bg=#ffffff;border=#000000",
    "color_bar_text": "#c8102e",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#c8102e",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 24, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 16, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 26, 2027",
    "kd_room_oncampus_deadline": "July 22, 2026",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Students will come to the Main Housing Office (Cleon Thompson Center Suite 301) to pick up their packages.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "wsu": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Washington State University",
    "sponsor_school": "Washington State University",
    "sponsor_org": "the Residence Hall Association and National Residence Hall Honorary",
    "primary_color": "#A60F2D",
    "internal_order_code": "wa-wsu",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/wsu-campus.jpg?v=1785291542",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "#A60F2D",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "bg=#4D4D4D",
    "kd_welcome_deadline": "August 21, 2026",
    "kd_welcome_availability": "August 31, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "December 7, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 26, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Community/Duncan Dunn", "Elmina White Honors", "Gannon/Goldsworthy", "Global Scholars", "McCroskey", "McEachern", "Northside", "Olympia", "Orton", "Regents", "Rogers", "Scott/Coman", "Stephenson", "Stimson", "Streit Perham", "Unknown"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "xavier": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": false,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": true, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": true, "care_off_springfinals": true,
    "name": "Xavier University",
    "sponsor_school": "Xavier University",
    "sponsor_org": "the Office of Residence Life",
    "primary_color": "#0b223f",
    "internal_order_code": "oh-xavier",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/xavier-campus.jpg?v=1787929374",
    "color_bar_bg": "",
    "color_bar_text": "",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "btn1_bg=#0033a0;btn2_bg=#0033a0",
    "color_fulfillment": "bg=#0033a0",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 26, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "February 27, 2027",
    "kd_springsurprise_availability": "March 8, 2027",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 28, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "School will notify the student with package pickup directions for each residence hall.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  },
  "york": {
    "care_on": true, "care_off": true,
    "room_on": false, "room_off": true,
    "care_on_welcome": false, "care_on_halloween": false,
    "care_on_fallfinals": true, "care_on_valentines": true,
    "care_on_springsurprise": false, "care_on_springfinals": true,
    "care_off_welcome": false, "care_off_halloween": false,
    "care_off_fallfinals": true, "care_off_valentines": true,
    "care_off_springsurprise": false, "care_off_springfinals": true,
    "name": "York University",
    "sponsor_school": "York University",
    "sponsor_org": "the Student Life Department",
    "primary_color": "#0047ba",
    "internal_order_code": "ne-york",
    "hero_image": "https://cdn.shopify.com/s/files/1/0668/0723/4603/files/york-campus.jpg?v=1787868187",
    "color_bar_bg": "bg=#ffffff;border=#0047ba",
    "color_bar_text": "#0047ba",
    "color_hero_text": "",
    "color_heading_room": "",
    "color_heading_bundles": "#000000",
    "color_heading_care_top": "",
    "color_heading_care_bottom": "#000000",
    "color_buttons": "",
    "color_fulfillment": "",
    "kd_welcome_deadline": "August 14, 2026",
    "kd_welcome_availability": "August 24, 2026",
    "kd_halloween_deadline": "October 10, 2026",
    "kd_halloween_availability": "October 29, 2026",
    "kd_fallfinals_deadline": "November 7, 2026",
    "kd_fallfinals_availability": "November 30, 2026",
    "kd_valentines_deadline": "January 23, 2027",
    "kd_valentines_availability": "February 11, 2027",
    "kd_springsurprise_deadline": "",
    "kd_springsurprise_availability": "",
    "kd_springfinals_deadline": "April 3, 2027",
    "kd_springfinals_availability": "April 7, 2027",
    "kd_room_oncampus_deadline": "",
    "kd_room_offcampus_deadline": "July 22, 2026",
    "care_faq": [{"question": "How does my student receive their care package?", "answer": "Care package pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": ""}],
    "room_faq": [{"question": "Where do I pick up my Room Essentials order?", "answer": "Room Essentials pickup details for this campus will be updated soon. Please check back or contact us for more information.", "section": "Room Essentials"}],
    "residence_halls": ["Not Required"],
    "room_required": "false",
    "room_label": "Room Number"
  }
};
